import { VerticalReport } from "./types";
import { formatMoney } from "./helpers";

interface Stat {
  label: string;
  value: string;
  emphasis?: "primary" | "muted";
}

export function SummaryStats({ report }: { report: VerticalReport }) {
  const stats: Stat[] = [
    { label: "Gross sales",    value: formatMoney(report.grossSales) },
    { label: "Tax",            value: formatMoney(report.tax),       emphasis: "muted" },
    { label: "Discounts",      value: formatMoney(report.discounts), emphasis: "muted" },
    { label: "Refunds",        value: formatMoney(report.refunds),   emphasis: "muted" },
    { label: "Tips",           value: formatMoney(report.tips),      emphasis: "muted" },
    { label: "Transactions",   value: report.transactionCount.toLocaleString() },
  ];

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 mb-4">
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {stats.map((s) => (
          <div key={s.label}>
            <div className="text-xs uppercase tracking-wider text-gray-500">{s.label}</div>
            <div className={`mt-1 text-lg font-semibold ${
              s.emphasis === "muted" ? "text-gray-700" : "text-gray-900"
            }`}>
              {s.value}
            </div>
          </div>
        ))}
      </div>

      {/* Net summary row — what the vendor actually keeps after fees. */}
      <div className="mt-4 pt-4 border-t border-gray-200 grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="text-xs uppercase tracking-wider text-gray-500">Organizer share</div>
          <div className="mt-1 text-lg font-semibold text-gray-700">
            {formatMoney(report.revenueShareCut + report.flatFee)}
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-wider text-gray-500">Net sales (vendor)</div>
          <div className="mt-1 text-2xl font-bold text-gray-900">
            {formatMoney(report.netSales)}
          </div>
        </div>
      </div>
    </div>
  );
}
